























































import throttle from 'lodash/throttle';
import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ChildComponentMixin from '@/common/ts/child-component/ChildComponentMixin';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';
import IntersectionDirective from '@/common/vue/intersection-directive';
import RelaunchButton from '@/common/vue/RelaunchButton.vue';
import ResponsiveImage from '@/common/vue/ResponsiveImage.vue';
import VideoPlayer from '@/common/vue/VideoPlayer.vue';
import WordFade from '@/common/vue/WordFade.vue';
import ExpandMedia from '@/webcomponents/expand-media/ExpandMedia.vue';
import i18n from '@/webcomponents/teaser-tiles/i18n';

const IconArrowRight = () => import('@/common/icons/arrow-right.svg');
const IconArrowRight16 = () => import('@/common/icons/arrow-right-16.svg');
const Co2Labeling = () => import('@/webcomponents/co2-labeling/Co2Labeling.vue');

const TeaserTilesItemProps = Vue.extend({
  props: {
    editMode: Boolean,
    headlineText: String,
    metaHeadline: String,
    linkText: String,
    linkUrl: String,
    pictureJson: String,
    singleItem: Boolean,
    desktopVideo: String,
    tabletVideo: String,
    mobileVideo: String,
    modelName: String,
    labelingJson: String,
    lastMouseXOffset: Number,
    aspectRatio: {
      type: String,
      default: '16by9',
      validator: (val) => ['16by9', '3by4'].includes(val),
    },
  },
});

@Component({
  components: {
    ExpandMedia,
    ResponsiveImage,
    WordFade,
    RelaunchButton,
    IconArrowRight,
    VideoPlayer,
    IconArrowRight16,
    Co2Labeling,
  },
  directives: {
    intersect: IntersectionDirective,
  },
  i18n,
})
export default class TeaserTilesItem extends mixins(TeaserTilesItemProps, ChildComponentMixin) {
  fadeIn = false;
  isSingle = false;
  backgroundColor = 'black';
  xOffset = 0;
  yOffset = 0;
  scrollOffsetY = 0;
  showButton = false;

  observerOptions = {
    threshold: 0.25,
  }

  $refs!: {
    headlineRef: WordFade;
    image: ResponsiveImage;
    mouseButton: HTMLElement;
  }

  get rootClass () {
    return {
      'brandhub-teaser-tiles-item--edit-mode': this.editMode,
      'brandhub-teaser-tiles-item--aspect-3by4': this.aspectRatio === '3by4',
      'brandhub-teaser-tiles-item--aspect-16by9': this.aspectRatio === '16by9',
      'brandhub-teaser-tiles-item--single-item': this.isSingle,
      'brandhub-teaser-tiles-item--in': this.fadeIn,
    };
  }

  get mouseButtonStyle () {
    return {
      '--teaserButtonVisibility': this.showButton ? 'visible' : 'hidden',
      '--teaserButtonXOffset': `${this.xOffset}px`,
      '--teaserButtonYOffset': `${this.yOffset}px`,
    };
  }

  handleIntersect (isIntersecting: boolean) {
    if (isIntersecting) {
      this.fadeIn = true;
      this.$refs.headlineRef.fadeInText();
    }
  }

  forceLoad () {
    this.$refs.image.loadingTriggered = true;
  }

  leaveImage () {
    this.showButton = false;
  }

  onItemClick (): void {
    if (this.linkUrl) {
      const link = this.linkUrl;
      const label = this.linkText;
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Teaser Tiles', label, link);
    }
  }

  onHoveringImage (event: MouseEvent) {
    this.showButton = true;
    const wrapperBoundingRect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    this.xOffset = event.clientX - wrapperBoundingRect.left;
    this.yOffset = event.clientY - wrapperBoundingRect.top;
  }

  handleScroll = throttle(() => {
    if (this.showButton && window.top.scrollY !== this.scrollOffsetY) {
      if (this.scrollOffsetY !== 0) {
        this.yOffset = this.yOffset + window.top.scrollY - this.scrollOffsetY;
      }
      this.scrollOffsetY = window.top.scrollY;
    }
  }, 50);

  created () {
    this.initChildComponentMixin(
      'TeaserTilesItem',
    );
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
